import { Plus, Trash2 } from "lucide-react";
import { Section, Field } from "./ProfileFields";

const SPECS = {
  experience: {
    title: "Work history", hint: "Most recent first. Write what you did in your own words; we'll turn it into strong bullet points.",
    add: "Add a job", item: "Job", max: 15, empty: { role: "", company: "", dates: "", location: "", description: "" },
    fields: [["role", "Job title", "e.g. Marketing Executive", 160], ["company", "Company", "e.g. DBS Bank", 160], ["dates", "Dates", "e.g. Jan 2022 - Present", 80],
      ["location", "Location", "e.g. Singapore", 120], ["description", "What you did", "Your main tasks and results. Add numbers if you have them, like team size or sales growth.", 3000, true]],
  },
  education: {
    title: "Education", hint: "Your highest qualifications first.", add: "Add education", item: "Qualification", max: 8,
    empty: { degree: "", institution: "", dates: "" },
    fields: [["degree", "Qualification", "e.g. Diploma in Business", 200], ["institution", "School", "e.g. Ngee Ann Polytechnic", 160], ["dates", "Dates", "e.g. 2018 - 2021", 80]],
  },
};

export default function ProfileList({ kind, items = [], onChange }) {
  const spec = SPECS[kind];
  const update = (i, k, v) => onChange(items.map((it, n) => (n === i ? { ...it, [k]: v } : it)));
  const add = () => onChange([...items, { ...spec.empty }]);
  const addBtn = items.length < spec.max && (
    <button data-testid={`profile-${kind}-add`} onClick={add} className="gi-btn gi-btn-secondary gi-btn-sm"><Plus className="w-4 h-4" aria-hidden="true" /> {spec.add}</button>
  );
  return (
    <Section title={spec.title} hint={spec.hint} testid={`profile-${kind}`} action={items.length > 0 && addBtn}>
      {items.length === 0 ? (
        <div className="rounded-xl border-2 border-dashed border-line p-6 text-center" data-testid={`profile-${kind}-empty`}>
          <p className="text-sm text-body mb-3">Nothing added yet.</p>
          {addBtn}
        </div>
      ) : (
        <ol className="space-y-4">
          {items.map((it, i) => (
            <li key={i} className="rounded-xl border border-line bg-canvas p-4" data-testid={`profile-${kind}-item-${i}`}>
              <div className="flex items-center justify-between mb-3">
                <span className="text-sm font-semibold text-ink">{spec.item} {i + 1}</span>
                <button data-testid={`profile-${kind}-remove-${i}`} onClick={() => onChange(items.filter((_, n) => n !== i))} aria-label={`Remove ${spec.item.toLowerCase()} ${i + 1}`}
                  className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm text-body hover:text-danger hover:bg-danger-soft transition-colors">
                  <Trash2 className="w-4 h-4" aria-hidden="true" /> Remove
                </button>
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                {spec.fields.map(([k, label, ph, max, area]) => (
                  <Field key={k} id={`profile-${kind}-${i}-${k}`} label={label} placeholder={ph} maxLength={max} textarea={area}
                    className={area ? "sm:col-span-2" : ""} value={it[k]} onChange={(v) => update(i, k, v)} />
                ))}
              </div>
            </li>
          ))}
        </ol>
      )}
    </Section>
  );
}
